import React from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';

interface Props {
	className?: string;
	width?: string | number;
	height?: string | number;
	borderRadius?: string | number;
}

const Skeleton: React.FC<Props> = ({ className, width, height, borderRadius }) => {
	const { Skeleton: css } = useTheme('Shared');

	return <div className={cn(css.skeleton, className)} style={{ width, height, borderRadius }} />;
};

export default Skeleton;
